module.exports = __webpack_public_path__ + "img/v3-issue-all.532e7a7d.svg";